import { ReactComponent as GreenCircleIcon } from '../../../assets/images/green_circle.svg'
import { ReactComponent as OrangeTriangleIcon } from '../../../assets/images/orange_triangle.svg'
import { ReactComponent as RedSquareIcon } from '../../../assets/images/red_square.svg'
import { ValueMessageColumnId, ValueMessageListItem, ValueMessageStatus } from './ValueMessageTable.types'

export const VALUE_MESSAGE_STATUSES: { id: ValueMessageStatus; icon: typeof GreenCircleIcon }[] = [
    { id: 'Supported', icon: GreenCircleIcon },
    { id: 'Supported-suboptimal', icon: OrangeTriangleIcon },
    { id: 'Aspirational', icon: RedSquareIcon },
]

export const ALWAYS_VISIBLE_VALUE_MESSAGE_COLUMN_IDS: ReadonlySet<string> = new Set<ValueMessageColumnId>(['name'])

export const DEFAULT_VALUE_MESSAGE_COLUMN_IDS: ReadonlySet<ValueMessageColumnId> = new Set([
    'name',
    'status',
    'category',
    'audiences',
])

export const getValueMessagePath = ({ _id, categoryId, narrativeId }: ValueMessageListItem) =>
    categoryId && narrativeId ? `/narratives/categories/${categoryId}/narratives/${narrativeId}/messages/${_id}` : null
